import { render, staticRenderFns } from "./WaterBalanceReportsDetailsDialog.vue?vue&type=template&id=864e5f2a&scoped=true&"
import script from "./WaterBalanceReportsDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./WaterBalanceReportsDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864e5f2a",
  null
  
)

export default component.exports